<template>
  <section class="pmp-card">
    <div class="pmp-section-head">
      <h1 class="pmp-section-title">Materia Prima</h1>
    </div>

    <div class="pmp-tpu-list">
      <article
        v-for="(item, index) in localForm.tpuItems"
        :key="item.id"
        class="pmp-tpu-card"
      >
        <span class="pmp-tpu-title"> TPU #{{ index + 1 }} </span>

        <button
          v-if="localForm.tpuItems.length > 1"
          type="button"
          class="pmp-tpu-remove"
          aria-label="Eliminar TPU"
          @click="$emit('remove-tpu', item.id)"
        >
          <i class="bi bi-trash" aria-hidden="true"></i>
        </button>

        <PMPDropdown
          v-model="item.proveedor"
          label="Proveedor"
          placeholder="Seleccionar proveedor"
          :options="proveedores"
          :error="Boolean(errors?.tpuItems?.[index]?.proveedor)"
          error-message="Selecciona un proveedor."
          @select="(option) => handleProveedorSelect(item, index, option)"
        />

        <div class="pmp-grid-2">
          <PMPField
            :model-value="item.cantidad"
            :id="`pmp-tpu-cantidad-${item.id}`"
            label="Cantidad"
            type="text"
            inputmode="decimal"
            min="0"
            step="0.01"
            max-digits="4"
            placeholder="0"
            :error="Boolean(errors?.tpuItems?.[index]?.cantidad)"
            error-message="Ingresa una cantidad válida."
            @update:modelValue="(value) => handleTpuCantidadInput(item, index, value)"
          />

          <PMPDropdown
            v-model="item.unidad"
            label="Unidad"
            placeholder="Unidad"
            :options="unidades"
            :error="Boolean(errors?.tpuItems?.[index]?.unidad)"
            error-message="Selecciona unidad."
            @select="(option) => handleUnidadSelect(item, index, option)"
          />
        </div>
      </article>
    </div>

    <button
      type="button"
      class="pmp-add-tpu-button"
      :disabled="isTpuLimitReached"
      :aria-disabled="isTpuLimitReached"
      @click="$emit('add-tpu')"
    >
      <i class="bi bi-plus-lg" aria-hidden="true"></i>
      <span>{{ isTpuLimitReached ? "Máximo 4 TPU" : "Agregar TPU" }}</span>
    </button>
  </section>
</template>

<script setup>
import { computed } from "vue";

import PMPField from "../components/PMPField.vue";
import PMPDropdown from "../components/PMPDropdown.vue";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  proveedores: {
    type: Array,
    default: () => [],
  },
  unidades: {
    type: Array,
    default: () => [],
  },
  errors: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["update:modelValue", "field-change", "add-tpu", "remove-tpu"]);

const localForm = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

const isTpuLimitReached = computed(() => {
  return (localForm.value.tpuItems || []).length >= 4;
});

function handleProveedorSelect(item, index, option) {
  item.proveedorLabel = option.label;
  notifyTpuFieldChange("proveedor", index);
}

function handleUnidadSelect(item, index, option) {
  item.unidadLabel = option.label;
  notifyTpuFieldChange("unidad", index);
}

function handleTpuCantidadInput(item, index, value) {
  item.cantidad = value; // ← PMPField ya filtra
  notifyTpuFieldChange("cantidad", index);
}

function notifyTpuFieldChange(field, index) {
  emit("field-change", {
    field: `tpuItems.${field}`,
    index,
  });
}
</script>
